import { Patient } from "./patientType"
import { MinimalUser } from "./user"

export const VISIT_STATUSES = [
	"UNSCHEDULED",
	"SCHEDULED",
	"COMPLETED",
	"CANCELLED",
] as const

type VisitStatus = (typeof VISIT_STATUSES)[number]

export const VISIT_TYPES = [
	"Footprint Installation",
	"Footprint Pickup",
	"Footprint Replacement",
] as const

export const MANUAL_VISIT_TYPES = [
	"Footprint Replacement",
	"Footprint Pickup",
] as const satisfies readonly (typeof VISIT_TYPES)[number][]

export type ManualVisitType = (typeof MANUAL_VISIT_TYPES)[number]

export interface VisitComment {
	id: string
	content: string
	authorId: string
	author: string
	createdAt: string
}

export interface Visit {
	id: string
	enrollmentId: string
	visitType: (typeof VISIT_TYPES)[number]
	status: VisitStatus
	allowedStatuses: VisitStatus[]
	unreadMessagesCount: number
	createdAt: string
	updatedAt: string
	patient?: Pick<
		Patient,
		| "id"
		| "fullName"
		| "address"
		| "email"
		| "phoneNumber"
		| "alternateContacts"
		| "hasCommunications"
	>
	fieldSupportAgents?: MinimalUser[]
	fieldSupportTeam?: { id: string; name: string }
	comments?: VisitComment[]
	visitDate?: string
	visitDurationInMinutes?: number
	notes?: string
	completedDate?: string
	cancelDate?: string
	installationPhotoUrl?: string
}

export type VisitPatient = Pick<
	Patient,
	"id" | "fullName" | "email" | "phoneNumber"
>

export type AdminVisitCreatePayload = {
	patientUserId: VisitPatient["id"]
	visitType: ManualVisitType
	fieldSupportTeamId: string
}

export type AdminVisitUpdatePayload = {
	status: Visit["status"]
	fieldSupportTeamId: string
	notes: string
	visitDate?: string
	completedDate?: string
	cancelDate?: string
	installationPhotoFile?: File
}

export type Steps = {
	linkFootprint?: boolean | undefined
	softwareUpdate?: boolean | undefined
	testScan?: boolean | undefined
	sendLink?: boolean | undefined
	imageUpload?: boolean | undefined
	unlinkFootprint?: boolean | undefined
}

export type Step = keyof Steps
